import { createFileRoute } from '@tanstack/react-router';

import FreeGamesListPage from '~/setup/free/FreeGamesListPage';

export const Route = createFileRoute('/_protected/freegames/')({
  validateSearch: (search: Record<string, unknown>) => ({
    gameId: typeof search.gameId === 'string' ? search.gameId : undefined,
  }),
  component: FreeGamesListPage,
});
